import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
// 引入封装好的api
import api from './api/index'
// 按需引入vant（全局可用）
import './utils/vant.js'
// 自定义css变量文件
import './static/css/var.css'
// vant-ui的全局css改变文件
import './static/css/changeVant.css'
// 引入vue-lottie动画组件
// import lottie from 'vue-lottie'
// 引入自定义组件作为全局组件
import viaNavBar from './components/common/via-nav-bar.vue'
import ViaStar from './components/common/via-star.vue'
// 引入动画库
import animated from 'animate.css'
// 引入腾讯事件库
import AlloyFinger from 'alloyfinger'
// 引入markdown编辑、解析器
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
// 引入图片hook函数
import { imageUrlHook } from './utils/func/imageUrlHook'

console.log(process.env)
Vue.config.productionTip = false

// 绑定api到全局
Vue.prototype.$api = api
// 使用lottie组件
// Vue.component('lottie', lottie)
// 使用自定义组件
Vue.component('viaNavBar', viaNavBar)
Vue.component('ViaStar', ViaStar)
// 使用动画库
Vue.use(animated)
// 使用markdown编辑、解析器
Vue.use(mavonEditor)
// 绑定腾讯事件库到全局
Vue.prototype.$finger = AlloyFinger
// 图片hook链接
Vue.prototype.$imgHook = imageUrlHook

// 屏幕宽
Vue.prototype.$clientWidth = document.documentElement.clientWidth
// 屏幕高
Vue.prototype.$clientHeight = document.documentElement.clientHeight

// 解析375rpx为屏幕真实的px
Vue.prototype.$rpxToPx = (rpx) => {
  const screenWidth = Vue.prototype.$clientWidth
  return parseFloat(rpx) / 375 * screenWidth
}
// 解析真实px为rpx
Vue.prototype.$pxToRpx = (px) => {
  const screenWidth = Vue.prototype.$clientWidth
  return parseFloat(px) / screenWidth * 375
}
// 解析px为vw
Vue.prototype.$pxToVw = (px) => {
  const screenWidth = Vue.prototype.$clientWidth
  return parseFloat(px) / screenWidth * 100
}
// 解析rpx为vw，不带单位
Vue.prototype.$rpxToVw = (rpx) => {
  return parseFloat(rpx) / 375 * 100
}
// 解析rpx为vw，带单位
Vue.prototype.$vw = (rpx) => {
  return parseFloat(rpx) / 375 * 100 + 'vw'
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
